import { FC } from 'react'
import { Stack, Typography } from '@dtx-company/design-system/src'
import { footerData } from './footer-data'
import Link from 'next/link'

export const TermsAndService: FC = () => (
  <Stack
    sx={{ justifyContent: 'center', alignItems: 'center', width: '100%', gridArea: 'trademark' }}
  >
    <Typography variant={'labelSmall'} style={{ color: 'white' }}>
      &copy;&nbsp;
      {`${new Date().getFullYear()} the dtx company`}
    </Typography>
  </Stack>
)

export const WhiteLabelFooter: FC = () => {
  return (
    <Stack
      sx={{
        zIndex: 9,
        px: 4,
        py: 2,
        backgroundColor: 'black',
        width: '100%',
        gridArea: 'footer'
      }}
      gap={2}
      justifyContent="center"
    >
      <Stack direction={'row'} gap={4} sx={{ width: '100%', justifyContent: 'center' }}>
        {footerData.map(link => (
          <Link href={link.href} key={link.href} target={link.target} rel={link.rel}>
            <Typography style={{ color: 'white' }} variant={'bodySmall'}>
              {link.label}
            </Typography>
          </Link>
        ))}
      </Stack>
      <TermsAndService />
    </Stack>
  )
}
